export enum DocumentsDeleteMutationTypes {
  SET_DOCUMENTS = 'SET_DOCUMENTS',
  SET_IS_OPEN = 'SET_IS_OPEN',
  SET_LOADING = 'SET_LOADING',
}
